import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Form, FormGroup, FormControl, Modal } from 'react-bootstrap';

import { handleError, createAiPrompt, updateAiPrompt } from '../AiToolsActions';

import Close from '../../../assets/images/close.svg';

import '../../../modules/Notifications/components/NotificationConfig.scss';

const defaultState = {
  model: {
    name: '',
    prompt: '',
    template: '',
    active: false,
  },
};

class PromptConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      isOpened: props.visible,
      readOnly: props.readOnly || false,
    };
  }

  componentDidMount() {
    if (this.props.model) {
      this.setModel();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.model, this.props.model)) {
      this.setModel();
    }
    if (prevProps.readOnly !== this.props.readOnly) {
      this.setState({ readOnly: this.props.readOnly });
    }
  }

  setModel() {
    const { model } = this.props;

    if (!model) return;

    this.setState({
      model: {
        _id: model._id,
        name: model.name || '',
        prompt: model.prompt || '',
        template: model.template || '',
        active: model.active || false,
      },
    });
  }

  onButtonClick = () => {
    if (!this.state.isOpened) {
      this.setState(
        {
          isOpened: true,
          readOnly: this.props.readOnly || false,
        },
        () => this.setModel()
      );
    }
  };

  onClose = (event, propagate) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      ...defaultState,
      isOpened: false,
      readOnly: false,
    });
    !!this.props.onClose && !!propagate && this.props.onClose();
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { model } = this.state;

    if (!model.name) {
      this.props.handleError('Specify name of the prompt');
      return false;
    }
    if (!model.prompt) {
      this.props.handleError('Specify prompt text');
      return false;
    }
    if (!model.template) {
      this.props.handleError('Specify template');
      return false;
    }

    if (model._id) {
      this.props.updateAiPrompt(model._id, this.formatModel(model));
    } else {
      this.props.createAiPrompt(this.formatModel(model));
    }
    this.onClose(null, true);
  };

  formatModel = (model) => {
    const result = {
      _id: model._id,
      name: model.name,
      prompt: model.prompt,
      template: model.template,
      active: model.active || false,
    };
    return result;
  };

  handleInput = (e) => {
    this.setState({
      model: {
        ...this.state.model,
        [e.target.name]: e.target.value,
      },
    });
  };

  render() {
    const { model, isOpened, readOnly } = this.state;

    const modal = (
      <Modal
        keyboard={false}
        backdrop={'static'}
        show={isOpened}
        onHide={this.onClose}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>{readOnly ? 'View Prompt' : model._id ? 'Edit Prompt' : 'Create New Prompt'}</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body className='form_content'>
          <Form onSubmit={this.handleSubmit}>
            <FormGroup controlId="name" className='mb-3'>
              <FormControl
                type="text"
                name="name"
                value={model.name}
                autoComplete="off"
                onChange={this.handleInput}
                disabled={readOnly}
                placeholder="Prompt Name"
              />
            </FormGroup>

            <FormGroup controlId="prompt" className='mb-3'>
              <FormControl
                as="textarea"
                rows={6}
                name="prompt"
                value={model.prompt}
                onChange={this.handleInput}
                disabled={readOnly}
                placeholder="Prompt Text"
              />
            </FormGroup>

            <FormGroup controlId="template">
              <FormControl
                as="textarea"
                rows={6}
                name="template"
                value={model.template}
                onChange={this.handleInput}
                disabled={readOnly}
                placeholder="Template"
              />
            </FormGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          {!readOnly && (
            <Button variant='primary' type="submit" onClick={this.handleSubmit}>
              {this.props.isLoading ? 'Loading...' : model._id ? 'Update' : 'Create'}
            </Button>
          )}
          <Button variant='secondary' onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    let content;
    if (this.props.children) {
      const btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          ...btn.props,
          onClick: this.onButtonClick,
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

PromptConfig.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  model: PropTypes.object,
  readOnly: PropTypes.bool,
};

PromptConfig.defaultProps = {
  visible: false,
  readOnly: false,
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleError: (msg) => dispatch(handleError(msg)),
    createAiPrompt: (model) => dispatch(createAiPrompt(model)),
    updateAiPrompt: (id, model) => dispatch(updateAiPrompt(id, model)),
  };
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.aiTools.isLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PromptConfig);
